/*
 * @author bai <ghimping@alpstein.my>
 * @link https://www.alpstein.my
 * @copyright Copyright (c) Alpstein Software
 *            _____                    _____                    _____
 *           /\    \                  /\    \                  /\    \
 *          /::\    \                /::\    \                /::\    \
 *         /::::\    \              /::::\    \               \:::\    \
 *        /::::::\    \            /::::::\    \               \:::\    \
 *       /:::/\:::\    \          /:::/\:::\    \               \:::\    \
 *      /:::/__\:::\    \        /:::/__\:::\    \               \:::\    \
 *     /::::\   \:::\    \      /::::\   \:::\    \              /::::\    \
 *    /::::::\   \:::\    \    /::::::\   \:::\    \    ____    /::::::\    \
 *   /:::/\:::\   \:::\ ___\  /:::/\:::\   \:::\    \  /\   \  /:::/\:::\    \
 *  /:::/__\:::\   \:::|    |/:::/  \:::\   \:::\____\/::\   \/:::/  \:::\____\
 *  \:::\   \:::\  /:::|____|\::/    \:::\  /:::/    /\:::\  /:::/    \::/    /
 *   \:::\   \:::\/:::/    /  \/____/ \:::\/:::/    /  \:::\/:::/    / \/____/
 *    \:::\   \::::::/    /            \::::::/    /    \::::::/    /
 *     \:::\   \::::/    /              \::::/    /      \::::/____/
 *      \:::\  /:::/    /               /:::/    /        \:::\    \
 *       \:::\/:::/    /               /:::/    /          \:::\    \
 *        \::::::/    /               /:::/    /            \:::\    \
 *         \::::/    /               /:::/    /              \:::\____\
 *          \::/____/                \::/    /                \::/    /
 *           ~~                       \/____/                  \/____/
 *
 */

import React, { Component } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import Theme from "../utils/Theme";
import { FormattedMessage } from "react-intl";
import { MdRestaurant } from "react-icons/md";
import { FaShoppingCart } from "react-icons/fa";
import { IoIosHeart, IoIosPerson } from "react-icons/io";
import TabItem from "../components/TabItem";

const StyledContainer = styled.div`
  position: absolute;
  width: 100%;
  background: #f9f9f9;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  height: 4em;
  bottom: 0;
  z-index: 10;
  box-shadow: 0 -3px 6px -5px grey;
`;

class TabBar extends Component {
  onTabClicked = index => {
    const { history, updateTabbarPosition, warningStatus } = this.props;

    if (warningStatus) {
      this.showWarning(true);
      return;
    }

    // if (currentPosition !== index) {
    if (updateTabbarPosition) {
      updateTabbarPosition(index);
    }

    switch (index) {
      case 0:
        history.push("/shop/stall");
        break;
      case 1:
        history.push("/shop/cart");
        break;
      case 2:
        history.push("/shop/favourite");
        break;
      case 3:
        history.push("/shop/me");
        break;
    }
    // }
  };

  showWarning = showWarningStatus => {
    const { showWarning } = this.props;

    showWarning(showWarningStatus);
  };

  render() {
    const { currentPosition, userCartItemLength, orderIndicator } = this.props;

    return (
      <StyledContainer>
        <TabItem
          index={0}
          currentIndex={currentPosition}
          onClick={this.onTabClicked}
          icon={<MdRestaurant />}
          color={"grey"}
          selectedColor={Theme.PrimaryColor}
          selectedIconColor={"white"}
          title={
            <FormattedMessage id="tab.stall.title" defaultMessage="Stall" />
          }
        />
        <TabItem
          badgeCount={userCartItemLength}
          index={1}
          currentIndex={currentPosition}
          onClick={this.onTabClicked}
          icon={<FaShoppingCart />}
          color={"grey"}
          selectedColor={Theme.PrimaryColor}
          selectedIconColor={"white"}
          title={
            <FormattedMessage id="tab.cart.title" defaultMessage="Stall" />
          }
        />
        <TabItem
          index={2}
          currentIndex={currentPosition}
          onClick={this.onTabClicked}
          icon={<IoIosHeart />}
          color={"grey"}
          selectedColor={Theme.PrimaryColor}
          selectedIconColor={"white"}
          title={
            <FormattedMessage id="tab.favourite.title" defaultMessage="Stall" />
          }
        />
        <TabItem
          redDot={orderIndicator}
          index={3}
          currentIndex={currentPosition}
          onClick={this.onTabClicked}
          icon={<IoIosPerson />}
          color={"grey"}
          selectedColor={Theme.PrimaryColor}
          selectedIconColor={"white"}
          title={<FormattedMessage id="tab.me.title" defaultMessage="Stall" />}
        />
      </StyledContainer>
    );
  }
}

TabBar.propTypes = {
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  currentPosition: PropTypes.object.isRequired,
  userCartItemLength: PropTypes.number,
  orderIndicator: PropTypes.bool,
  displayWarning: PropTypes.bool,
  warningStatus: PropTypes.bool,
  showWarning: PropTypes.func,
  updateTabbarPosition: PropTypes.func
};

export default TabBar;



// WEBPACK FOOTER //
// ./src/components/TabBar.js